import { ConsentManagementService } from './ConsentManagementService';
import { SetActiveProfile } from './Config/ActiveProfile';
import { init as initialiseViewState } from './ConsentApp';

(() => {
  try {
    SetActiveProfile('TEMPLATE_PROFILE_ID');

    initialiseViewState();

    (window as any).ConsentManagement = new ConsentManagementService();
  } catch (e) {
    e.stack = e.stack || e.toString();
    console.error('there was a problem starting consent management', e.stack, e);
    throw e;
  }
})();
